import routerOptions0 from "/var/www/z_ipm/public_html/Sites_Front_End/subdomain/live/httpdocs/node_modules/.pnpm/nuxt@3.17.5_@netlify+blobs@8.2.0_@parcel+watcher@2.5.1_@types+node@22.15.3_db0@0.3.2_eslint@9_yql7tzzvcs66r2mjvamkrgjz6a/node_modules/nuxt/dist/pages/runtime/router.options.js";
const configRouterOptions = {
  hashMode: false,
  scrollBehaviorType: "auto"
}
export const hashMode = false
export default {
...configRouterOptions,
...routerOptions0,
}